import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loadingPage: false,
        page: null,
        flag: {
            type: '',
            text: ''
        }
    }
}

const parsePage = (responseData) => {
    const data = responseData && responseData.data ? responseData.data : {}
    return data.page || data.item || data
}

const loadPage = (instance) => {
    instance.setState({ ...instance.state, loadingPage: true })

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/page',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then((response) => handleResponse(instance, response))
    .catch((error) => {
        instance.setState({
            ...instance.state,
            loadingPage: false,
            flag: {
                type: 'error',
                text: 'Failed to load page. Please retry.'
            }
        })
        alert(error)
    })
}

const handleResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        instance.setState({
            ...instance.state,
            loadingPage: false,
            page: parsePage(response.data),
            flag: {
                type: '',
                text: ''
            }
        })
        return
    }

    if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
        return
    }

    instance.setState({
        ...instance.state,
        loadingPage: false,
        flag: {
            type: 'error',
            text: response.data.message || 'Page not found.'
        }
    })
}

const DetailsWorker = (instance) => {
    return {
        getDefaultState: () => getDefaultState(),
        loadPage: () => loadPage(instance)
    }
}

export default DetailsWorker
